/*
 * Copyright (c) 2018 Infowijs.
 * Created by Thomas Schoffelen.
 */

let searchWidget
let lastSearchQuery = ''

function initSearch () {
  if (searchWidget) {
    searchWidget.dispose()
  }

  let filters = window.config.schoolSlug && !window.config.searchAll &&
  window.config.schoolSlug !== 'algemeen' && window.config.schoolSlug !== 'district'
    ? '(schoolSlug:"' + window.config.schoolSlug + '" OR schoolSlug:"district")'
    : ''

  try {
    searchWidget = instantsearch({
      appId: 'ABOARC8X9F',
      apiKey: '1c110b29cea05e83dce945e2c5594f2f',
      indexName: window.config.searchIndex,
      searchParameters: {
        hitsPerPage: 12,
        filters: filters
      },
      searchFunction (helper) {
        const empty = helper.state.query.replace(/(^\s+|\s+$)/, '') === ''
        $('.search-results').toggle(!empty)

        if ('widget' in window.config) {
          $('.search-empty').toggle(empty)
        }

        if (empty) {
          return
        }

        helper.search()

        lastSearchQuery = helper.state.query
        trackSearchThrottled(helper.state.query)
      }
    })

    const hasMobileSearch = $('.mobile-search').length

    searchWidget.addWidget(
      instantsearch.widgets.searchBox({
        container: '#search-input'
      })
    )
    if (hasMobileSearch) {
      searchWidget.addWidget(
        instantsearch.widgets.searchBox({
          container: '#search-input-mobile'
        })
      )
    }

    const schoolLabel = !window.config.singleMode ? '<span class="hit-label" style="background-color: {{schoolColor}};">{{schoolName}}</span>' : ''
    searchWidget.addWidget(
      instantsearch.widgets.hits({
        container: '#hits',
        escapeHits: true,
        transformData: {
          item: function (data) {
            data.isLink = data.type === 'link'
            data.isNotLink = data.type !== 'link'
            return data
          }
        },
        templates: {
          item: '<a href="{{path}}" {{#isLink}}target="_blank"{{/isLink}} class="hit-content hit-type-{{type}}">{{#isLink}}<i class="icon-globe"></i>{{/isLink}}{{#thumbnail}}<img src="{{thumbnail}}" onerror="$(this).hide()" />{{/thumbnail}}' +
            schoolLabel +
            '<span class="hit-title">{{{ _snippetResult.title.value }}}</span><span class="hit-body">{{#isLink}}Website{{/isLink}}{{#isNotLink}}{{{ _snippetResult.body.value }}}{{/isNotLink}}</span></a>',
          empty: '<div class="hit-empty">We konden geen resultaten vinden voor <em>{{query}}</em>...' +
            ('schoolwikiWidget' in window ? '<a href="' + (window.config.schoolUrl || '/') + '" target="_blank" class="search-export">Naar de Schoolwiki &rarr;</a>' : '') + '</div>'
        }
      })
    )
    if (hasMobileSearch) {
      searchWidget.addWidget(
        instantsearch.widgets.hits({
          container: '#hits-mobile',
          escapeHits: false,
          transformData: {
            item: function (data) {
              data.isLink = data.type === 'link'
              data.isNotLink = data.type !== 'link'
              return data
            }
          },
          templates: {
            item: '<a href="{{path}}" {{#isLink}}target="_blank"{{/isLink}} class="hit-content hit-type-{{type}}">{{#isLink}}<i class="icon-globe"></i>{{/isLink}}{{#thumbnail}}<img src="{{thumbnail}}" onerror="$(this).hide()" />{{/thumbnail}}' +
              schoolLabel +
              '<span class="hit-title">{{{ _snippetResult.title.value }}}</span><span class="hit-body">{{#isLink}}Website{{/isLink}}{{#isNotLink}}{{{ _snippetResult.body.value }}}{{/isNotLink}}</span></a>',
            empty: '<div class="hit-empty">We konden geen resultaten vinden voor <em>{{query}}</em>...' + '</div>'
          }
        })
      )
    }

    searchWidget.start()
  } catch (e) {
    // Don't do anything
  }
}

function showSearch () {
  $('.search-overlay').fadeIn()
  $('.search-input').focus()
}

function hideSearch () {
  $('.search-overlay').fadeOut()
  $('.search-input').blur()
}

$(document).on('click', '.nav-item-search a', function (e) {
  e.preventDefault()
  e.stopPropagation()

  showSearch()
})

$(document).on('click', '.hit-content', function () {
  hideSearch()

  trackSearchThrottled(lastSearchQuery)

  const href = $(this).attr('href')
  const headingIndex = href.indexOf('#a')
  const foundQuery = $(this).find('em').first().text()

  if (headingIndex > 0) {
    $(document).one('pjax:end', function () {
      handleSearchComplete(href, headingIndex, foundQuery)
    })
    handleSearchComplete(href, headingIndex, foundQuery)
  }
})

function handleSearchComplete (href, headingIndex, foundQuery) {
  const $target = $(href.substring(headingIndex))
  if (!$target.length) {
    return
  }

  // Highlight matched search terms
  const instance = new Mark($target.get())
  instance.mark(foundQuery)
  setTimeout(function() {
    instance.unmark()
  }, 5600)

  let offsetDelta = 120

  // Expand matching
  const $accordions = $target.parents('.block-accordion:not(.open)')
  if ($accordions.length) {
    $accordions.parents('.block-accordions').first().find('.block-accordion.open').first().removeClass('open')
    $accordions.first().addClass('open')
    offsetDelta += 120
  }

  // Scroll down to matching article
  const offset = $target.offset().top - offsetDelta
  setTimeout(() => {
    const timeout = tocScrollToPos(offset)
    setTimeout(updateTocIndex, timeout)
  }, 50)
}

$(document).keyup(function (e) {
  if (e.which === 191 && !$(document.activeElement).is('textarea, input')) {
    showSearch()
  }
  if (e.which === 27) {
    hideSearch()
  }
})

initSearch()
$(document).on('pjax:end', initSearch)
